// removed by extract-text-webpack-plugin
module.exports = {"root":"_2YDIh"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Input/Group/Group.scss
// module id = 1343
// module chunks = 0